import { render, staticRenderFns } from "./SwitchChannel.vue?vue&type=template&id=1ed5b7d3&scoped=true&"
import script from "./SwitchChannel.vue?vue&type=script&lang=js&"
export * from "./SwitchChannel.vue?vue&type=script&lang=js&"
import style0 from "./SwitchChannel.vue?vue&type=style&index=0&id=1ed5b7d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5b7d3",
  null
  
)

export default component.exports